// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9697) return "static/chunks/9697.93becd668cacea24.js";
	if (chunkId === 8028) return "static/chunks/8028.5d17f263d110814a.js";
	if (chunkId === 8285) return "static/chunks/8285.aea372b2e012f945.js";
	if (chunkId === 8655) return "static/chunks/e217e3ef.e4ae557152285f8a.js";
	if (chunkId === 8626) return "static/chunks/aa40b463.4e5afae7be99d58f.js";
	if (chunkId === 4329) return "static/chunks/4329.d9dab9f1971af187.js";
	if (chunkId === 3842) return "static/chunks/3842.adb7673836a3f928.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1850":"92940365f9fb0c29","2256":"1caf01575796a949","3358":"f20a6d2468f2658b","4665":"670eb587fb2575f1","5566":"f5871c7282969128","6325":"6c803959e184acf3","7791":"92dd4d8b1fa6b8e1","9915":"bbb1297b0da94584"}[chunkId] + ".js";
};